import { MemreContainer, MemreFlexBox, MemreNoResults } from 'components/core';
import * as Color from 'core/colors';
import GoalProgress from './GoalProgress';
import SecureMemories from './SecureMemories';
import SinceLastStudy from './SinceLastStudy';
import StudyDuration from './StudyDuration';

interface KnowledgeBankVisWithDataProps {
  data: any[];
  isCoursesView?: boolean;
  isStudentsView?: boolean;
}

export default function KnowledgeBankVisWithData({
  data,
  isCoursesView = false,
  isStudentsView = false,
}: KnowledgeBankVisWithDataProps) {
  if (!data || data.length === 0) {
    return (
      <MemreFlexBox
        direction="row"
        justify="center"
        sx={{
          p: 4,
          borderTop: `1px solid ${Color.lightGray}`,
          backgroundColor: Color.veryLightGray,
        }}
      >
        <MemreNoResults />
      </MemreFlexBox>
    );
  }

  return (
    <>
      <MemreFlexBox
        direction="row"
        sx={{
          borderTop: `1px solid ${Color.veryLightGray}`,
          borderBottom: `1px solid ${Color.veryLightGray}`,
        }}
      >
        <SinceLastStudy data={data} isStudentsView={isStudentsView} isCoursesView={isCoursesView} />
        <SecureMemories data={data} isStudentsView={isStudentsView} isCoursesView={isCoursesView} />
        <StudyDuration data={data} isStudentsView={isStudentsView} isCoursesView={isCoursesView} />
      </MemreFlexBox>

      <MemreContainer
        size="large"
        direction={{
          xs: 'column',
          lg: 'row',
        }}
      >
        <GoalProgress data={data} isStudentsView={isStudentsView} isCoursesView={isCoursesView} />
      </MemreContainer>
    </>
  );
}
